import { useTranslation } from "react-i18next";
import { Container, Row, Col, Form } from "react-bootstrap";
import Header from "./components/header";
import {
  Divider,
  FaqSection,
  HomeWrapper,
  HomepageTopSection,
  HomepageTopSectionButtons,
  HomepageTopSectionMain,
  JoinContent,
  JoinForm,
  JoinLabel,
  JoinSection,
  ProgramSection,
  SectionContent,
  SectionImg,
  SectionRow,
  SolutionCard,
  SolutionCardHeader,
  SolutionCards,
  SolutionSection,
} from "./components/styles/Homepage.styled";
import { Button } from "./components/styles/HomePageButton.styled";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { contactUs } from "./api/api";
import { useRef, useState } from "react";
import FAQAccordion from "./components/Accordion";

export const Homepage = () => {
  const { t } = useTranslation("homepage");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const applyRef = useRef<null | HTMLDivElement>(null);
  const solutionRef = useRef<null | HTMLDivElement>(null);
  const faqRef = useRef<null | HTMLDivElement>(null);

  const images = [
    "https://dorzjv601fuva.cloudfront.net/tx/194.png",
    "https://dorzjv601fuva.cloudfront.net/tx/183.png",
    "https://dorzjv601fuva.cloudfront.net/tx/210.png",
    "https://dorzjv601fuva.cloudfront.net/tx/239.png",
    "https://dorzjv601fuva.cloudfront.net/tx/186.png",
    "https://dorzjv601fuva.cloudfront.net/tx/196.png",
    "https://dorzjv601fuva.cloudfront.net/tx/258.png",
    "https://dorzjv601fuva.cloudfront.net/tx/269.png",
    "https://dorzjv601fuva.cloudfront.net/tx/159.png",
    "https://dorzjv601fuva.cloudfront.net/tx/176.png",
    "https://dorzjv601fuva.cloudfront.net/tx/206.png",
    "https://dorzjv601fuva.cloudfront.net/tx/163.png",
    "https://dorzjv601fuva.cloudfront.net/tx/167.png",
    "https://dorzjv601fuva.cloudfront.net/tx/166.png",
  ];

  const handleScrollApply = () => {
    if (applyRef && applyRef.current) {
        applyRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const handleScrollSolution = () => {
    if (solutionRef && solutionRef.current) {
        solutionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const handleScrollFaq = () =>{
    if (faqRef && faqRef.current) {
      faqRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const { name, email, company, message, phone, industry } = event.target.elements;
    const { value: _name } = name;
    const { value: _email } = email;
    const { value: _company } = company;
    const { value: _message } = message;
    const { value: _phone } = phone;
    const { value: _industry } = industry;
  
    if (_name == null || _name.trim() === "") {
      toast.error("Please enter your name.");
      return;
    }
  
    if (_email == null || _email.trim() === "") {
      toast.error("Please enter your email address.");
      return;
    } else if (!/^\S+@\S+\.\S+$/.test(_email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    if (_company == null || _company.trim() === "") {
      toast.error("Please enter your company name.");
      return;
    }
  
    if (_phone == null || _phone.trim() === "") {
      toast.error("Please enter your phone number.");
      return;
    } else if (!/^[\d\s\-\+\(\)]{10,}$/.test(_phone)) {
      toast.error("Please enter a valid phone number.");
      return;
    }
  
    if (_industry == null || _industry.trim() === "") {
      toast.error("Please select your business type.");
      return;
    }
  
    if (_message == null || _message.trim() === "") {
      toast.error("Please enter your message.");
      return;
    }
  
    setLoading(true);
    contactUs(_name, _email, _company, _message, _phone, _industry)
      .then((res: any) => {
        if (res.status === "1") {
          toast.success("Message sent successfully!");
          event.target.reset();
        } else {
          toast.error("Network error, please try again");
        }
      })
      .catch((error: any) => {
        toast.error("An error occurred, please try again");
        console.error("Submission error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <HomeWrapper>
      <Header isHeader handleScroll={handleScrollSolution} />
      <Container>
        <HomepageTopSection>
          <HomepageTopSectionMain>
            <h1>Earn by Referring Shoppers to the Right Energy Deals</h1>
            <p className="home-p">
              Earn immediate commissions with our out-of-the-box solution when
              customers sign up for any of our shopping plans. Start referring
              today!
            </p>
            <HomepageTopSectionButtons>
              <Button onClick={()=>handleScrollApply()}>Become a partner</Button>
              {/* <Button variant="secondary" onClick={() => handleScrollFaq()}>
                Faqs
              </Button> */}
            </HomepageTopSectionButtons>
          </HomepageTopSectionMain>
          <img src="/images/bg-home.png" />
        </HomepageTopSection>
        <ProgramSection>
          <h4>Get Started</h4>
          <h3>
            Step-by-Step Guide to Earning
            with Our Partner Program
          </h3>
          <Divider />
          <SectionRow reverse>
            <SectionContent>
              <p className="step-title">Step 1</p>
              <h2>Submit Your Application</h2>
              <p>
                Submit your application through our partner portal. We'll review
                your information and schedule a quick call to get you started.
              </p>
              <Button onClick={() => handleScrollApply()}>Apply Now</Button>
            </SectionContent>
            <SectionImg>
              <img src="/images/step1.png" alt="" />
            </SectionImg>
          </SectionRow>
          <SectionRow>
            <SectionContent>
              <p className="step-title">Step 2</p>
              <h2>Complete Onboarding</h2>
              <p>
                Our partner team quickly sets you up with the right ready-to-use
                referral method: choose from simple affiliate link or turnkey
                whitelabel solution.
              </p>
            </SectionContent>
            <SectionImg>
              <img src="/images/step2.png" alt="" />
            </SectionImg>
          </SectionRow>
          <SectionRow reverse>
            <SectionContent>
              <p className="step-title">Step 3</p>
              <h2>Start Making Referrals</h2>
              <p>
                Our system tags your referrals. Once your referrals order is
                marked as complete you are eligible for compensation.
              </p>
            </SectionContent>
            <SectionImg>
              <img src="/images/step3.png" alt="" />
            </SectionImg>
          </SectionRow>
          <SectionRow style={{marginBottom:"0"}}>
            <SectionContent>
              <p className="step-title">Step 4</p>
              <h2>Get Your Payment</h2>
              <p>
                Each month we email you a detailed report of your referrals and
                process your commissions.
              </p>
            </SectionContent>
            <SectionImg>
              <img src="/images/step4.png" alt="" />
            </SectionImg>
          </SectionRow>
        </ProgramSection>
      </Container>
      <JoinSection ref={applyRef}>
        <Container>
          <JoinContent>
            <JoinLabel>
              <h3>Apply to Join</h3>
              <p>
                Start by submitting this form for Partner Program. We’ll go over
                your details and schedule a short call to get you on board.
              </p>
            </JoinLabel>
            <JoinForm>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col xs={12} md={6}>
                    <Form.Group controlId="name">
                      <Form.Label>Name *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Your name and surname"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group controlId="email">
                      <Form.Label>Email *</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Your email address"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6}>
                    <Form.Group controlId="company">
                      <Form.Label>Company Name *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your company name"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group controlId="phone">
                      <Form.Label>Phone *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your phone number"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6}>
                    <Form.Group controlId="industry">
                      <Form.Label>Industry *</Form.Label>
                      <Form.Control as="select" required>
                        <option value="" disabled selected>Please select</option>
                        <option value="Retail Energy Provider and Supplier">Retail Energy Provider and Supplier</option>
                        <option value="Energy Broker">Energy Broker</option>
                        <option value="Startup Energy Firm">Startup Energy Firm</option>
                        <option value="Solar Company">Solar Company</option>
                        <option value="Home Services/HVAC">Home Services/HVAC</option>
                        <option value="Other">Other</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group controlId="message">
                  <Form.Label>Describe your business *</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    placeholder="How do you plan to use our platform?"
                  />
                </Form.Group>
                <Button variant="primary" type="submit" disabled={loading}>
                  SUBMIT APPLICATION
                </Button>
              </Form>
            </JoinForm>
          </JoinContent>
        </Container>
      </JoinSection>
      <Container>
        <SolutionSection ref={solutionRef}>
          <h3>Explore Live Solutions</h3>
          <p className="solution-p">See how Residential Customers and Businesses experience power shopping with our reference implementations.</p>
          <SolutionCards>
            <SolutionCard onClick={()=>{navigate("/residential");window.scrollTo(0, 0);}}>
              <SolutionCardHeader>
                <h5>Residential</h5>
                <img src="/images/icon-arrow-right.png" className="share"/>
              </SolutionCardHeader>
              <img src="/images/logo.png" className="logo"/>
              <p>A consolidated Texas energy marketplace to find lowest cost residential power plans.</p>
              <img src="/images/residential.png" className="solution-bg"/>
            </SolutionCard>
            <SolutionCard onClick={()=>{navigate("/smb");window.scrollTo(0, 0);}}>
              <SolutionCardHeader>
                <h5>Small/Medium Businesses</h5>
                <img src="/images/icon-arrow-right.png" className="share"/>
              </SolutionCardHeader>
              <img src="/images/logo.png" className="logo"/>
              <p>An energy broker platform catering for small and medium-sized businesses (SMBs).</p>
              <img src="/images/small-businesses.png" className="solution-bg"/>
            </SolutionCard>
          </SolutionCards>
        </SolutionSection>
        <FaqSection ref={faqRef}>
          <h3>Frequently Asked Questions</h3>
          <Divider/>
          <FAQAccordion/>
        </FaqSection>
      </Container>
    </HomeWrapper>
  );
};
